import EditAdminForm from './component'

export default EditAdminForm
